import type { Router, RouteRecordRaw } from 'vue-router'
import { usePermissionsStore } from 'modules/login/model/permissions.store'
import { PageName } from 'shared/lib/types/app/pages'

export const moduleRoute: RouteRecordRaw = {
  path: 'outbox-notifications',
  name: PageName.OUTBOX_NOTIFICATIONS,
  component: () => import('./pages/OutboxNotificationsIndex.vue'),
  beforeEnter: () => usePermissionsStore().showOutboxQueue || { name: PageName.ERROR_403 },
  meta: {
    breadcrumbName: 'Уведомления outbox',
    breadcrumbOnly: true,
  },
}

export default (router: Router) => {
  router.addRoute(PageName.MAIN_LAYOUT, moduleRoute)
}
